'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M320 960h384v64h-384zM320 832h384v64h-384zM320 704h384v64h-384zM512 0l448 448h-256v192h-384v-192h-256z' })
    ));
};